import { Grid } from '@mui/material'
import { useMutation } from '@tanstack/react-query'
import { AppBox, AppButton, SimpleField } from 'components'
import { ApiQueryKeys } from 'globals/constants'
import { enqueueSnackbar, useSnackbar } from 'notistack'
import { Dispatch, FC, SetStateAction, useRef, useState } from 'react'
import { CityApi, PaginationFilterModel } from 'sdk'

interface Props {
  filter: PaginationFilterModel
  setFilter: Dispatch<SetStateAction<PaginationFilterModel>>
}
export const CityDataActions: FC<Props> = ({ filter, setFilter }) => {
  const cityApi = new CityApi()
  const { enqueueSnackbar } = useSnackbar()
  const fileInputRef = useRef<HTMLInputElement | null>(null)
  const { mutate: uploadFile, isPending: isUploading } = useMutation({
    mutationKey: [ApiQueryKeys.city.uploadCities],
    mutationFn: (file: File) => cityApi.uploadCities(file),
    onSuccess: () => {
      enqueueSnackbar('Cities data is being uploaded in background', { variant: 'success' })
    },
    onError: (err) => enqueueSnackbar(err.message, { variant: 'error' }),
  })

  // Handle file selection
  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0]

    if (file) {
      const validExtensions = ['.csv', '.xls', '.xlsx']
      const fileExtension = file.name.substring(file.name.lastIndexOf('.')).toLowerCase()

      if (validExtensions.includes(fileExtension)) {
        uploadFile(file)
      } else {
        enqueueSnackbar('Invalid file type. Please select a CSV or Excel file.', { variant: 'error' })
        event.target.value = '' // Reset input
      }
      event.target.value = '' // Reset input
    }
  }
  return (
    <>
      <AppBox display={'flex'} alignItems={'center'} gap={1} justifyContent={'space-between'}>
        <Grid item>
          <SimpleField
            prefixIcon="iconamoon:search-bold"
            placeholder="Search City Data"
            onChange={(event) => setFilter((prev) => ({ ...prev, PageNo: 1, Query: event.target.value }))}
          />
        </Grid>
        <AppButton
          variant="contained"
          size="large"
          isLoading={isUploading}
          onClick={() => fileInputRef.current?.click()}
        >
          Upload New
        </AppButton>
        <input
          type="file"
          ref={fileInputRef}
          style={{ display: 'none' }} // Hide the input
          accept=".csv, .xls, .xlsx"
          onChange={handleFileChange}
        />
      </AppBox>
    </>
  )
}
